const BASE_ENDPOINT = process.env.REACT_APP_BASE_API_URL;

export { BASE_ENDPOINT };
